import { EmailAuthProvider, GoogleAuthProvider } from "firebase/auth";
import { collection, doc, onSnapshot, updateDoc } from "firebase/firestore";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Badge } from "./Badge";
import { Button } from "./Button";
import { FirebaseContext } from "./context";
import { IUserBadge, IUserProfile } from "./models";
import { Photo } from "./Photo";
import { TextBlock } from "./TextBlock";


export const PageUser = () => {
    const navigate = useNavigate();
    const { db, user } = useContext(FirebaseContext);
    const [ profile, setProfile ] = useState<IUserProfile | undefined>(undefined);
    const [ badges, setBadges ] = useState<IUserBadge[]>([]);
    const params = useParams();
    useEffect(() => {
        if(user && user.uid === params.id){
            navigate('/me');
        }
    }, [user, params.id])
    useEffect(() => {
        console.log(`Getting ${params.id}`);
        return onSnapshot(doc(db!, 'v2-users', params.id as string), (snapshot) => setProfile(snapshot.data() as IUserProfile));
    }, [params.id]);
    useEffect(() => {
        return onSnapshot(collection(db!, 'v2-users', params.id as string, 'badges'), (snapshot) => setBadges(snapshot.docs.map((d) => {
            return { ...d.data(), id: d.id } as IUserBadge;
        })));
    }, [params.id]);
    if(profile){
        return <div className="px-36 py-10">
            <div className="flex space-x-10 flex-wrap">
                <div className="mb-10">
                    <Photo src={profile!.avatar} size="large"/>
                    <div className="-translate-y-full flex justify-between">
                        <div className="opacity-0 w-36 h-36 bg-[#01487C] rounded-full"></div>
                        <div className="flex flex-col justify-end">
                            <div className="w-20 h-20 bg-[#01487C] rounded-full -translate-x-1/4 -translate-y-1/4"></div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='flex mb-7'>
                        {badges?.map((b) => <Badge key={b.id} image={b.image} size='middle' title={b.title}/>)}
                    </div>
                    <TextBlock className="text-4xl mb-7" defaultValue={profile.name} editable={false}/>
                    <p className="text-gray-500">О себе:</p>
                    <TextBlock className="text-lg" defaultValue={profile.bio.length > 0 ? profile!.bio : "Нет биографии"} editable={false}/>
                </div>
            </div>
        </div>
    }
    else{
        return <div>
            <p>Загрузка профиля...</p>
        </div>
    }
}